export default "__VITE_ASSET__D$_ki$vJ__"